var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main mt-3"},[_c('div',{staticClass:"row ml-0 mr-0"},[_c('div',{staticClass:"col-lg-9 col-md-8"},[_c('router-view')],1),_c('div',{staticClass:"col-lg-3 col-md-4 pl-lg-5 pl-md-2 mt-5 menu-profile"},[_c('div',{staticClass:"mb-2"},[_c('Profile')],1),_c('div',[_c('MenuProfile')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }